// Central theme utilities
// Reads CSS variable --brand so you can change color in one place (style.css)

export const getBrandColor = () => {
  try {
    if (typeof window !== "undefined" && window.getComputedStyle) {
      const value = getComputedStyle(document.documentElement)
        .getPropertyValue("--brand")
        .trim();
      if (value) return value;
    }
  } catch (_) {
    // ignore
  }
  return "#339966"; // fallback
};


